import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=8a7464dc&scoped=true&"
import script from "./HomeIcon.vue?vue&type=script&lang=js&"
export * from "./HomeIcon.vue?vue&type=script&lang=js&"
import style0 from "./HomeIcon.vue?vue&type=style&index=0&id=8a7464dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7464dc",
  null
  
)

export default component.exports